import { wsService } from './wsService';
import sections from '@/constants/sections';

const section = sections.SECTION_PRODUCTION_ORDERS;


function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_status() {
    return wsService.make_post_request(section + "/list-status");
}
function list_status_internal() {
    return wsService.make_post_request(section + "/list-status-internal");
}

function changeToInExecution(param = {}) {
    return wsService.make_post_request(section + "/change-to-in-execution", param);
}

function cancelOrders(param = {}) {
    return wsService.make_post_request(section + "/cancel-orders", param);
}

function changeInternalState(param = {}) {
    return wsService.make_post_request(section + "/change-internal-state", param);
}

function finishOrder(param = {}) {
    return wsService.make_post_request(section + "/finish-production-order", param);
}

function getStatusHistory(production_order_id) {
    return wsService.make_get_request(section + "/" + production_order_id + "/status-history");
}

function getInternalStateHistory(production_order_id) {
    return wsService.make_get_request(section + "/" + production_order_id + "/internal-state-history");
}

function print(formula_id) {
  return wsService.make_post_request(
    section + "/print",
    { id: formula_id },
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

function printLabel(data) {
  return wsService.make_post_request(
    section + "/print-label",
    data,
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

export const productionOrderService = {
  section,
  filter,
  remove,
  create,
  update,
  list_status,
  list_status_internal,
  changeToInExecution,
  cancelOrders,
  changeInternalState,
  finishOrder,
  getStatusHistory,
  getInternalStateHistory,
  print,
  printLabel
};
